// iter932 — Session-level cache for global config lookups (Company Settings +
// Tax Rates). Same pattern as hooks/useTaxConfig.loadTaxConfig: in-memory cache
// + in-flight promise dedup so these are fetched at most ONCE per session even
// when many pages/components request them on mount. Call invalidateConfigCache()
// after any settings/tax-rate save so the next read refetches.
import api from '@/lib/api';

const _cache = new Map();     // key -> resolved data
const _inflight = new Map();  // key -> pending promise

async function _cachedGet(key, url, fallback) {
  if (_cache.has(key)) return _cache.get(key);
  if (_inflight.has(key)) return _inflight.get(key);
  const p = (async () => {
    try {
      const res = await api.get(url);
      _cache.set(key, res.data);
      return res.data;
    } catch {
      _cache.set(key, fallback);
      return fallback;
    } finally {
      _inflight.delete(key);
    }
  })();
  _inflight.set(key, p);
  return p;
}

export function getCompanySettings() {
  return _cachedGet('company_settings', '/settings/company', {});
}

export function getTaxRates() {
  return _cachedGet('tax_rates', '/accounting/tax-rates', []);
}

export function invalidateConfigCache(key) {
  if (key) { _cache.delete(key); _inflight.delete(key); }
  else { _cache.clear(); _inflight.clear(); }
}
